import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';
import {modifyPageLayoutComponents} from '../PageLayout';
import template from '../../templates/Stores/Stores.rt';
import {logout} from '../../actions';
import StoresHeaderTemplate from '../../templates/Stores/StoresHeader.rt';
import {getStores, changeStoreStatus} from '../../actions/stores';

const mapStateToProps = state => ({
  searchKeyword: state.stores.searchKeyword,
  stores: state.stores.data.rows,
  page: state.stores.data.page,
  totalPages: state.stores.data.totalPages,
  statusUpdateSuccess: state.stores.statusUpdateSuccess,
  userRoles: state.auth.roles
});

const mapDispatchToProps = dispatch => ({
  getStores: (page, limit, searchKeyword) => dispatch(getStores(page, limit, searchKeyword)),
  changeStoreStatus: (storeId, enabled) => dispatch(changeStoreStatus(storeId, enabled)),
  setSearchTerm: (value) => {
    dispatch(getStores(0, 50, value));
  },
  logout: () => dispatch(logout())
});

class Stores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      expandedRowId: 0,
      showExpandedRow: false,
      showFabricatorPopup: false,
      showStoresPopup: false,
      showPermissionsPopup: false,
      isDropDownOpened: false,
      activeUser: {},
      activeDropDownValue: 'Stores',
      dropdownValues: [
        'Fabricators',
        'Employees',
        'Customers'
      ]
    }
  }

  componentWillMount() {
    this.props.getStores();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.statusUpdateSuccess) {
      this.props.getStores(this.state.page, 50);
    }
  }

  handleActivateEntity = (entityId, enabled) => {
    this.props.changeStoreStatus(entityId, !enabled);
  }

  handleDropDownChange = (value) => {
    this.setState({isDropDownOpened: !this.state.isDropDownOpened});

    if (value) {
      hashHistory.push(value.toLowerCase());
    }
    ;
  }

  handleShowPopup = (userId, popupName, nested) => {
    let activeUser;
    if (nested) {
      activeUser = this.props.stores.find(str => str.id == this.state.expandedRowId).users
        .find(user => user.id === userId)
    } else {
      activeUser = this.props.stores.find(str => str.id == userId)
    }

    const newState = {
      activeUser: activeUser
    };

    switch (popupName) {
      case "fabricators":
        newState.showFabricatorPopup = !this.state.showFabricatorPopup;
        newState.popupName = popupName;
        break;
      case "stores":
        newState.showStoresPopup = !this.state.showStoresPopup;
        newState.popupName = popupName;
        break;
      case "permissions":
        newState.showPermissionsPopup = !this.state.showPermissionsPopup;
        break;
    }
    this.setState(newState);
  }

  handleClosePopup = (popupName) => {
    const newState = {};
    switch (popupName) {
      case "fabricators":
        newState.showFabricatorPopup = false;
        break;
      case "stores":
        newState.showStoresPopup = !this.state.showStoresPopup;
        break;
      case "permissions":
        newState.showPermissionsPopup = false;
        break;
    }
    this.setState(newState);
  }

  handleExpandRow = (expandedRowId) => {
    if (expandedRowId === this.state.expandedRowId) {
      this.setState({showExpandedRow: !this.state.showExpandedRow});
    } else {
      this.setState({
        expandedRowId,
        showExpandedRow: true
      });
    }
  }

  handleRedirect = (entityId, clientType, clientSubType) => {
    let redirectUrl = 'account'
    if (entityId && clientType && clientSubType) {
      redirectUrl += `?entityId=${entityId}&clientType=${clientType}&clientSubType=${clientSubType}`
    } else if (!entityId && clientType && clientSubType) {
      redirectUrl += `?clientType=${clientType}&clientSubType=${clientSubType}`
    } else if (clientSubType) {
      redirectUrl += `&clientSubType=${clientSubType}`
    }
    hashHistory.push(redirectUrl)
  }

  handlePaginate = (page) => {
    this.setState({page: page - 1});
    this.props.getStores(page - 1, 50);
  }

  render = template
}

Stores.propTypes = {
  stores: PropTypes.array,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  statusUpdateSuccess: PropTypes.bool,
  getStores: PropTypes.func.isRequired,
  changeStoreStatus: PropTypes.func.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const StoresLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(StoresHeaderTemplate),
  content: connector(Stores)
});

